import { render, staticRenderFns } from "./CityWiseVcctTested.vue?vue&type=template&id=f1b90bea&scoped=true&"
import script from "./CityWiseVcctTested.vue?vue&type=script&lang=js&"
export * from "./CityWiseVcctTested.vue?vue&type=script&lang=js&"
import style0 from "./CityWiseVcctTested.vue?vue&type=style&index=0&id=f1b90bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b90bea",
  null
  
)

export default component.exports